export function getBase64FromFile(f: File) {
  return ((f: File) =>
    new Promise<string>((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(f);
      reader.onload = () => resolve(reader.result as string);
      reader.onerror = () => reject();
    }))(f);
}

export function getBase64FromBlob(b: Blob) {
  return ((blob: Blob): Promise<string> =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.onloadend = () => {
        const base64String = reader.result as string;
        resolve(base64String);
      };
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    }))(b);
}

export function getFileExtension(name: string) {
  return name.split('.').at(-1);
}

export function isImage(base64: string) {
  const imageRegex = /^data:image\/(png|jpeg|jpg|gif|webp|bmp|tiff);base64,/;
  return imageRegex.test(base64);
}
